<template>
  <div>
    <!-- Mostrar contenido -->
    <PostContainer
      v-if="element.available"
      :element="element"
      :model="model"
    />
    <!-- Mostrar BLOQUEADO-->
    <PostBlockedContainer
      v-else-if="!element.available && ['normal', 'premium', 'free'].includes(element.front_container)"
      :post="element"
      :model="model"
    />
    <!-- Mostrar ELSE -->
    <div v-else>
      {{$t('video_watch.not_available')}}
    </div>
  </div>
</template>
<script>
import PostContainer from "./PostContainer";
import PostBlockedContainer from "./PostBlockedContainer";

export default {
  name: 'PostSorter',
  components: {PostContainer, PostBlockedContainer},
  props: {
    element: {},
    model: {}
  },
  mounted() {
  },
  computed: {
  }
}
</script>
